<template>
  <!-- Only responsible for managing the top-level routing (SignUp vs SignIn) -->
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App'
};
</script>
